import { type WorkflowsClientInterface } from './workflowsClient.types';
import CorporateWorkflowsClient from './corporateWorkflowsClient';
import type { ClientContext } from '~/services/contextClient';

export default class WorkflowsClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId' | 'orgUnitId'>): WorkflowsClientInterface {
        return new CorporateWorkflowsClient(context.teamId);
    }
}
